import { useState } from 'react';
import { Box, Button, Flex, Heading, IconButton } from '@chakra-ui/react';
import { FaRegPaperPlane } from 'react-icons/fa';
import { RiFilter2Line } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import PaginationRouterContainer from '@components/PaginationRouterContainer';
import Loading from '@components/Loading';
import useGetList from '@hooks/useGetUsersList';
import usePaginationParams from '@hooks/usePaginationParams';

import InviteDialog from './components/InviteDialog';
import UserCard from './components/UserCard';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const User = () => {
  const [showInviteDialog, setShowInviteDialog] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const { checkIfHasRole } = useAuthContext();

  const {
    getUsers,
    users,
    totalPages,
    loading,
  } = useGetList();

  usePaginationParams({ onParamsChange: getUsers });

  const getCurrentComponent = () => {
    if (loading && users.length === 0) return <Loading />;

    if (!loading && users.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum usuário encontrado.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {users.map((user) => (
            <UserCard
              key={user.id}
              user={user}
              refetch={() => getUsers({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Heading>Usuários</Heading>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        {checkIfHasRole('CAN_INVITE_USERS') && (
          <Button size="sm" onClick={() => setShowInviteDialog(true)}>
            <FaRegPaperPlane /> Convidar
          </Button>
        )}
      </Flex>

      {showFilters ? (
        <Filters onClose={() => setShowFilters(false)} />
      ) : (
        <SelectedFiltersList />
      )}

      {getCurrentComponent()}

      {showInviteDialog && (
        <InviteDialog
          handleClose={() => setShowInviteDialog(false)}
        />
      )}
    </Box>
  );
};

export default User;
